const localStorageNamePrefix = "my"
export default {
  document: {
    message: `${localStorageNamePrefix}-message`,
  },
}
